var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item", class: { active: _vm.open } },
    [
      _c(
        "button",
        {
          staticClass: "btn-toggle",
          on: {
            click: function($event) {
              _vm.open = !_vm.open
            }
          }
        },
        [
          _vm._v(_vm._s(_vm.title) + " "),
          _c("i", { staticClass: "icon-arrow-toggle" })
        ]
      ),
      _c(
        "vue-slide-toggle",
        { attrs: { open: _vm.open, tag: "section", duration: 500 } },
        [
          _c("div", {
            staticClass: "desc",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }